'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppUserEmail() {
}
export { $c_Lapp_data_AppUserEmail as $c_Lapp_data_AppUserEmail };
$c_Lapp_data_AppUserEmail.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppUserEmail.prototype.constructor = $c_Lapp_data_AppUserEmail;
/** @constructor */
function $h_Lapp_data_AppUserEmail() {
}
export { $h_Lapp_data_AppUserEmail as $h_Lapp_data_AppUserEmail };
$h_Lapp_data_AppUserEmail.prototype = $c_Lapp_data_AppUserEmail.prototype;
$c_Lapp_data_AppUserEmail.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.data.-App-User-Email.js.map
